module.exports = __webpack_public_path__ + "assets/a983c660faa3d2a1f4ae55dc9c703459.mp3";